// extracted by mini-css-extract-plugin
module.exports = {"section":"LandingAI_section__gxhaU","title":"LandingAI_title__kvD_k"};